import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAllAvailableCountryOptions } from '@anytag/shared-hooks';
import { SelectorField, SingleSelectorFieldProps } from '@anytag/shared-molecules';
import { MarketplaceFormKeys, MarketplaceFormValues } from '../types';

export const CountryField = (
  props: Omit<SingleSelectorFieldProps<MarketplaceFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const { allAvailableCountryOptions } = useAllAvailableCountryOptions();
  const { setValue, watch } = useFormContext<MarketplaceFormValues>();
  const countryIdValue = watch(MarketplaceFormKeys.countryId);

  useEffect(() => {
    if (allAvailableCountryOptions.length) {
      const currency = allAvailableCountryOptions.find((country) => country.value === countryIdValue)?.currency || '';
      setValue(MarketplaceFormKeys.currency, currency);
    }
  }, [countryIdValue, allAvailableCountryOptions.length]);

  return (
    <SelectorField
      title={t('Selector.Campaign Country')}
      help={t('Tooltip.Select Campaign Help')}
      options={allAvailableCountryOptions}
      name={MarketplaceFormKeys.countryId}
      {...props}
    />
  );
};
